import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * `/inviter/import` no longer has a page body: the mapping step it used to
 * own moved into the unified `/inviter` page (spec §3, decision 3 — see
 * inviter.index.tsx). This route survives as a redirect only because it is
 * linked from `/invitations` history and may be bookmarked — it must not
 * 404.
 */
export const Route = createFileRoute("/_dashboard/inviter/import")({
  beforeLoad: () => {
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect({ to: "/inviter", search: { mode: "import" } });
  },
});
